import * as iconsCSS from './icons.scss';
const icons = __NATIVE__ ? iconsCSS : iconsCSS.default;

function parseIconNames() {
  const iconNames = Object.keys(icons);

  return iconNames.reduce((obj, name) => {
    const key = name.replace(/-/g, '_');
    obj[key.toUpperCase()] = name;
    return obj;
  }, {});
}

export default parseIconNames(icons);
